export default __webpack_public_path__ + "static/media/particles-web-theme7.0121d9fb.svg";